export enum ArincFOMEnum {
  TERMINAL_USE = "0: DOC < 25[NM] - ALTITUDE < 12000[FT]",
  LOW_ALTITUDE_USE = "1: DOC < 40[NM] - ALTITUDE < 18000[FT]",
  HIGH_ALTITUDE = "2: DOC < 130[NM] - ALTITUDE < 60000[FT]",
  EXTENDED_HIGH_ALTITUDE = "3: DOC > 130[NM]",
  NOT_INCLUDED = "7: NOT INCLUDED",
  OUT_OF_SERVICE = "9: OUT OF SERVICE"
}
